import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

interface BackHeaderProps {
  title: string;
  onBack: () => void;
  className?: string;
  backLabel?: string; // Added optional prop for flexibility
}

const BackHeader: React.FC<BackHeaderProps> = ({
  title,
  onBack,
  className = '',
  backLabel = 'Back'
}) => {
  return (
    <div className={`flex items-center mb-6 ${className}`}>
      {/* Back Button Group */}
      <button
        onClick={onBack}
        aria-label={`Go back to previous page`}
        className="group flex items-center text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 rounded-md py-1 pr-2"
      >
        <ArrowLeftIcon className="w-5 h-5 mr-2 transition-transform duration-200 ease-in-out group-hover:-translate-x-1" />
        {backLabel}
      </button>

      {/* Vertical Divider */}
      <div
        className="h-6 w-px bg-gray-300 mx-4 hidden sm:block"
        aria-hidden="true"
      />

      {/* Page Title */}
      <h1 className="text-2xl font-bold tracking-tight text-gray-900">
        {title}
      </h1>
    </div>
  );
};

export default BackHeader;
